import Banner from './Banner';

export function DevDeploymentWarning() {
  return (
    <Banner
      open={true}
      intent="info"
      title="Development deployments cannot be upgraded to Production type"
      description={
        <span className="text-xs text-tertiary">
          Development type deployments are provisioned on preemptible compute{' '}
          infrastructure. See the{' '}
          <a
            target="_blank"
            className="underline"
            href="https://docs.langchain.com/langgraph-platform/control-plane#development"
          >
            docs
          </a>{' '}
          for more details.
        </span>
      }
      className="mb-4"
      shadow={false}
    />
  );
}
